module.exports = __webpack_public_path__ + "img/1 test 2022 (1).638ba95f.jpg";